/**
 * Individual sample card component.
 */
import { Sample } from '@/services/api'

interface SampleCardProps {
  sample: Sample
  onEdit: (sample: Sample) => void
  onDelete: (sampleId: string) => void
}

export const SampleCard: React.FC<SampleCardProps> = ({
  sample,
  onEdit,
  onDelete,
}) => {
  const truncate = (text: string, maxLength: number) => {
    if (text.length <= maxLength) return text
    return text.substring(0, maxLength) + '...'
  }

  return (
    <div className="card hover:shadow-lg transition-shadow">
      {/* Sample Notes Preview */}
      <div className="mb-4">
        <h4 className="text-sm font-semibold text-gray-500 uppercase mb-2">
          Example Notes
        </h4>
        <p className="text-gray-700 text-sm leading-relaxed">
          {truncate(sample.notes_text, 150)}
        </p>
      </div>

      {/* Sample Report Preview */}
      <div className="mb-4">
        <h4 className="text-sm font-semibold text-gray-500 uppercase mb-2">
          Example Report
        </h4>
        <p className="text-gray-700 text-sm leading-relaxed">
          {truncate(sample.report_text, 150)}
        </p>
      </div>

      {/* Metadata */}
      <div className="text-xs text-gray-500 mb-4">
        Created: {new Date(sample.created_at).toLocaleDateString()}
      </div>

      {/* Actions */}
      <div className="flex space-x-2">
        <button
          onClick={() => onEdit(sample)}
          className="btn-secondary text-sm flex-1"
        >
          Edit
        </button>
        <button
          onClick={() => {
            if (window.confirm('Are you sure you want to delete this sample?')) {
              onDelete(sample.sample_id)
            }
          }}
          className="btn-danger text-sm flex-1"
        >
          Delete
        </button>
      </div>
    </div>
  )
}
